import { ElementItemProps } from "../types";
import ElementFrame from "./ElementFrame";

export interface UnknownElementParameters {
  type: string;
  parameters: { [key: string]: unknown };
}

const UnknownElement = ({ type, parameters, configKey, elementKey, disabled }: Omit<ElementItemProps<UnknownElementParameters>, "label">) => {
  return (
    <ElementFrame label={type} disabled={disabled}>
      <pre>{JSON.stringify({ type, parameters, configKey, elementKey, disabled }, null, 2)}</pre>
    </ElementFrame>
  );
};

export default UnknownElement;
